import { RefreshCw } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import type { AssessmentReview } from '../../mentorshipService';

type Props = {
    review: AssessmentReview;
    onRegenerate: () => void;
    regenerating: boolean;
};

function AssessmentReviewSummary({ review, onRegenerate, regenerating }: Props) {
    const [low, high] = review.suggested_score_range;
    const levelCls = `mentorship-chip mentorship-chip--level-${review.level_mapping.toLowerCase()}`;

    return (
        <Card variant="stacked" className="assessment-review">
            <Card.Header>
                <h3>AI mentor-assist</h3>
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<RefreshCw size={14} />}
                    onClick={onRegenerate}
                    disabled={regenerating}
                >
                    {regenerating ? 'Regenerating…' : 'Regenerate'}
                </Button>
            </Card.Header>
            <Card.Body>
                <p>
                    Suggested score range: <strong>{low}–{high}</strong>
                    <span className={levelCls} style={{ marginLeft: 8 }}>
                        {review.level_mapping}
                    </span>
                </p>
                {review.review_focus.length > 0 && (
                    <div className="assessment-review__focus">
                        <h4>Focus on</h4>
                        <ul>
                            {review.review_focus.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                    </div>
                )}
                <p className="assessment-review__confidence">
                    AI confidence {Math.round(review.confidence * 100)}%
                </p>
            </Card.Body>
        </Card>
    );
}

export default AssessmentReviewSummary;
